import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { FinancialStrengthRatio } from '../../types'

export const columns: (
    t: Function
) => GridColDefVNW<FinancialStrengthRatio>[] = (_t) => [
    {
        field: 'report_month',
        headerName: 'month',
        width: 120,
        renderCell: ({ value }) => {
            const [year, month] = value.split('-')
            const monthNames = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ]
            return (
                <div className="font-medium">
                    {monthNames[parseInt(month) - 1]} {year}
                </div>
            )
        },
    },
    {
        field: 'current_ratio',
        headerName: 'current_ratio',
        width: 150,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
            </div>
        ),
    },
    {
        field: 'quick_ratio',
        headerName: 'quick_ratio',
        width: 150,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
            </div>
        ),
    },
    {
        field: 'interest_coverage',
        headerName: 'interest_coverage',
        width: 170,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
            </div>
        ),
    },
    {
        field: 'debt_to_equity_ratio',
        headerName: 'debt_to_equity_ratio',
        width: 180,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
            </div>
        ),
    },
    {
        field: 'notes',
        headerName: 'notes',
        width: 300,
        flex: 1,
        renderCell: ({ value }) => (
            <div className="text-sm text-gray-600 truncate">{value || '-'}</div>
        ),
    },
]
